"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addInkhubMonthly = addInkhubMonthly;
exports.batchDeleteInkhubMonthly = batchDeleteInkhubMonthly;
exports.getInkhubMonthlyByPeriod = getInkhubMonthlyByPeriod;
exports.queryInkhubMonthly = queryInkhubMonthly;
exports.updateInkhubMonthly = updateInkhubMonthly;
var _request = _interopRequireDefault(require("@/utils/request"));
// 查询 Inkhub 每月精选列表
function queryInkhubMonthly(data) {
  return (0, _request.default)({
    url: 'equipment/inkhub-featured/query',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

// 新增 Inkhub 每月精选（集合）
function addInkhubMonthly(data) {
  return (0, _request.default)({
    url: 'equipment/inkhub-featured/add',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

// 按期数查询该期全部语言
function getInkhubMonthlyByPeriod(period) {
  return (0, _request.default)({
    url: 'equipment/inkhub-featured/' + encodeURIComponent(period),
    method: 'get',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    }
  });
}

// 按期修改：请求体同新增，languages 项可带 id（已有语言）
function updateInkhubMonthly(data) {
  return (0, _request.default)({
    url: 'equipment/inkhub-featured/update',
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

// 批量删除
function batchDeleteInkhubMonthly(data) {
  return (0, _request.default)({
    url: 'equipment/inkhub-featured/delete',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}